import { NgModule } from "@angular/core";
import { CoreCommonModule } from '@core/common.module';
import { CommonModule } from '@angular/common';
import { FileUploadModule } from 'ng2-file-upload';
import { FileUploaderDropzoneComponent } from "./file-uploader-dropzone.component";

@NgModule({
  declarations: [
    FileUploaderDropzoneComponent,
  ],
  imports: [ 
    CommonModule,
    CoreCommonModule,
    FileUploadModule
  ],
  exports: [
    FileUploaderDropzoneComponent
  ]
})
export class FileUploaderDropzoneModule {

}